import addPrecedingSlash from '@helpers/add-preceding-slash'
import addTrailingSlash from '@helpers/add-trailing-slash'

const addBothEndSlashes = str => addPrecedingSlash(addTrailingSlash(str))

export default addBothEndSlashes
